import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { QuibblService } from '../quibbl.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReviewComponent implements OnInit {

  public quibbls;
  public quibblSubscription;
  public now = Date.now();
  public selectedQuibbl;
  public modalOpen = false;

  public selectedAnswer = -1;

  constructor(private _qb: QuibblService) { }

  ngOnInit() {
    this.quibblSubscription =
      this._qb.getQuibbls(null, null, true).subscribe(quibbls => {
        this.quibbls = [];
        for(let i=quibbls.length-1; i>=0; i--) {
          quibbls[i].readMore = (quibbls[i].readMore) ? quibbls[i].readMore : '';
          this.quibbls.push(quibbls[i]);
        }
      });
  }

  ngOnDestroy() {
    if(this.quibblSubscription) this.quibblSubscription.unsubscribe();
  }

  public selectQuibbl(quibbl: any) {
    this.selectedAnswer = -1;
    this.selectedQuibbl = quibbl;
    this.modalOpen = true;
  }

  public selectIndex(index: number) {
    let identifier = this.selectedQuibbl.$key;
    this.selectedAnswer = index;
    //console.log("Marked " + index + " as correct for " + identifier);
  }

  public toggleQuibbl(quibbl) {
    this._qb.setQuibblPin(quibbl.$key, !quibbl.pinned);
  }

  public closeAndSave(save: boolean) {
    this.modalOpen = false;

    if(save && this.selectedAnswer > -1) {
      //console.log("Saving correct answer and distributing points.");
      this._qb.markAnswerAndCloseQuibbl(this.selectedQuibbl.$key, this.selectedAnswer);
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/review/review.component.ts